module.exports = __webpack_public_path__ + "img/francis-goeltner-thesiege-earl-skeep.aaa6da71.jpg";